import { render, staticRenderFns } from "./ReservationBatchSmsSend.vue?vue&type=template&id=084f9594&"
import script from "./ReservationBatchSmsSend.vue?vue&type=script&lang=js&"
export * from "./ReservationBatchSmsSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports